@media screen and (-webkit-min-device-pixel-ratio: 0), (-moz-images-in-menus: 0), (-moz-images-in-menus: 0) {
  select:focus,
  textarea:focus,
  input:focus {
    font-size: 16px;
  }
}

#root {
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
}
